const PREFIX = 'recash_cache_'
const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000 // 24h

interface CacheEntry<T> {
  data: T
  timestamp: number
  ttl: number
}

export const offlineCache = {
  set<T>(key: string, data: T, ttlMs = DEFAULT_TTL_MS): void {
    try {
      const entry: CacheEntry<T> = { data, timestamp: Date.now(), ttl: ttlMs }
      localStorage.setItem(PREFIX + key, JSON.stringify(entry))
    } catch {
      // localStorage plein → ignorer silencieusement
    }
  },

  get<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(PREFIX + key)
      if (!raw) return null
      const entry: CacheEntry<T> = JSON.parse(raw)
      if (Date.now() - entry.timestamp > entry.ttl) {
        localStorage.removeItem(PREFIX + key)
        return null
      }
      return entry.data
    } catch {
      return null
    }
  },

  getStale<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(PREFIX + key)
      if (!raw) return null
      const entry: CacheEntry<T> = JSON.parse(raw)
      return entry.data
    } catch {
      return null
    }
  },

  getTimestamp(key: string): Date | null {
    try {
      const raw = localStorage.getItem(PREFIX + key)
      if (!raw) return null
      const entry: CacheEntry<unknown> = JSON.parse(raw)
      return new Date(entry.timestamp)
    } catch {
      return null
    }
  },

  remove(key: string): void {
    localStorage.removeItem(PREFIX + key)
  },

  clear(): void {
    Object.keys(localStorage)
      .filter(k => k.startsWith(PREFIX))
      .forEach(k => localStorage.removeItem(k))
  },
}

// Clés standardisées pour chaque endpoint
export const CACHE_KEYS = {
  HOME_STATS: 'home_stats',
  WALLET: 'wallet',
  TICKETS: 'tickets',
  PROFILE: 'profile',
  ALERTS: 'alerts',
}
